import { getApi , postApi , putApi , deleteApi } from "../api";

export const getAllBusinessCardApi = () => getApi(`/user/getBusinessCard`);